module.exports = __webpack_public_path__ + "static/media/074.4eb68ccc.jpg";